module.exports = require("@pb/kit-component-info");